import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {
    GameSessionPromotionEvents,
    GameSessionPromotionModule
} from '@gongxigames/framework/promotions';

export class GameSessionPromotionEndState extends ModuleState<null, GameSessionPromotionModule, GameSessionPromotionEvents> {
    public onEnterState(): void {
        this.emit('General.Promotion.Campaign.Ended');

        const promotionData = this.module.getPromotion().getData();
        const endPopup = this.module.popups.createGameSessionPromotionEndPopup({
            ...promotionData,
            onClickContinue: this.onClickContinue.bind(this),
            onClickExit: this.onClockExit.bind(this)
        });

        this.module.showPopup(endPopup);
    }

    private onClickContinue(): void {
        this.emit('General.Window.RELOAD');
    }

    private onClockExit(): void {
        this.emit('General.Window.GO_TO_HOME');
    }

    public onLeaveState(): void {
        this.emit('General.Promotion.Ended');
    }
    protected setupEvents(): void {}
}
